import { callDeepLink } from '@croquiscom/web2app';

import { useCatalogProductIdParams, usePdpConfig } from '@domains/pdp-common';

import { useEpickStylelistUBL } from '../log/useEpickStylelistUBL';

export const useEpickStylist = () => {
  const { catalog_product_id } = useCatalogProductIdParams();
  const { pageviewEpickStylelist, clickEpickStylelistItem } = useEpickStylelistUBL();

  const { isZigzagApp } = usePdpConfig();
  const country = 'KR';
  const is_korea = country === 'KR';

  const handleItemClick = (post_id: string, landing_url: string) => {
    clickEpickStylelistItem(catalog_product_id, post_id);

    if (isZigzagApp) {
      callDeepLink('/full_screen_simple_browser')({
        url: encodeURIComponent(landing_url),
      });
      return;
    }

    window.open(landing_url);
  };

  const handleItemImpression = (post_id: string) => {
    pageviewEpickStylelist(catalog_product_id, post_id);
  };

  return {
    is_korea,
    handleItemClick,
    handleItemImpression,
  };
};
